import '@leanpay/ui/main.css'

import React from 'react'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'

import { announceStoredGoogleConsent } from '@leanpay/utils'

import App from 'app/app'
import { gtmId, isProdEnvironment } from 'library/constants'

import './index.css'

import { initI18n } from './i18n'

if (isProdEnvironment) {
    const tagManagerArgs = {
        gtmId,
    }

    TagManager.initialize(tagManagerArgs)
    announceStoredGoogleConsent()
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

// Initialize i18n before rendering
initI18n().then(() => {
    ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    )
})
